import React, { useEffect, useState, useRef } from 'react';
import FadeIn from 'react-fade-in';
import { toJS } from 'mobx';

import QuickDrawerHeader from '../../../../_shared/QuickDrawerHeader';

import * as ErrorMessages from '../../../../../../constants/errorMessages';
import * as fn from '../../../../../../utilities/_functions';

import './UpdateCommunicationTemplateVariable.scss';

function UpdateCommunicationTemplateVariable(props) {
    const isMounted = useRef(true);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [selectedFormat, setSelectedFormat] = useState(null);

    useEffect(() => {
        parseSelectedItem(props);
        return (() => {
            isMounted.current = false;
        })
    }, []) // eslint-disable-line

    const parseSelectedItem = (props) => {
        const { variable, selectedItem } = props.extraProps || {};

        if (variable && selectedItem) {
            const Format = {
                id: selectedItem,
                text: null,
                isTextChangeAllowed: false,
                buttonSizes: [],
                buttonSize: null,
            };

            const buttonMatch = Format.id.match(/(\S*Button)(\d+)?/);

            if (buttonMatch) {
                Format.id = buttonMatch && buttonMatch.length > 1 ? Format.id.replace(buttonMatch[0], buttonMatch[1]) : Format.id;
                Format.buttonSizes = ['80', '100'];
                Format.buttonSize = buttonMatch && buttonMatch.length > 2 ? buttonMatch[2] : null;
            }

            const formatMatch = Format.id.match(/^([^[]+)\[([^\]]+)\]$/);

            Format.id = formatMatch && formatMatch.length > 1 ? formatMatch[1] : Format.id;
            Format.text = formatMatch && formatMatch.length > 2 ? formatMatch[2] : null;

            const format = toJS(variable.formats.find(f => f.variable === Format.id));

            Format.text = format.isTextChangeAllowed ? Format.text : null;
            Format.isTextChangeAllowed = format.isTextChangeAllowed;

            setSelectedFormat(Format);
        }
    }

    const getTextChangeLabel = (id) => {
        if (id) {
            if (/Link$/.test(id)) {
                return <small>Link text</small>;
            }
            else if (/Button$/.test(id)) {
                return <small>Button text</small>
            }
            else if (/^ServiceFee/.test(id)) {
                return <small>Service code</small>
            }
        }

        return <small>Text</small>;
    }

    const handleCancel = () => {
        if (fn.isFunction(props.onCancel)) {
            if (hasUnsavedChanges) {
                if (window.confirm(ErrorMessages.DISCARD_CHANGES)) {
                    props.onCancel();
                }
            } else {
                props.onCancel();
            }
        }
    }

    const handleFormatChange = (event, format) => {
        if (isMounted.current) {
            const SelectedFormat = JSON.parse(JSON.stringify(selectedFormat));
            SelectedFormat.id = format.variable;
            SelectedFormat.isTextChangeAllowed = format.isTextChangeAllowed;
            setSelectedFormat(SelectedFormat);
            setHasUnsavedChanges(true);
        }
    }

    const handleFormatTextChange = (event) => {
        if (isMounted.current) {
            const { value } = event.target;
            const SelectedFormat = JSON.parse(JSON.stringify(selectedFormat));
            SelectedFormat.text = value;
            setSelectedFormat(SelectedFormat);
            setHasUnsavedChanges(true);
        }
    }

    const handleButtonSizeChange = (event, value) => {
        if (isMounted.current) {
            const SelectedFormat = JSON.parse(JSON.stringify(selectedFormat));
            SelectedFormat.buttonSize = value;
            setSelectedFormat(SelectedFormat);
            setHasUnsavedChanges(true);
        }
    }

    const handleSubmit = event => {
        event.preventDefault();
        if (isMounted.current) {
            if (props.onSuccess && fn.isFunction(props.onSuccess)) {
                const selectedId = `${selectedFormat.id}${selectedFormat.buttonSizes && selectedFormat.buttonSizes.length > 0 && selectedFormat.buttonSize ? selectedFormat.buttonSize : ''}${selectedFormat.isTextChangeAllowed === true && selectedFormat.text ? `[${selectedFormat.text}]` : ''}`;
                const newProps = { ...props.extraProps, ...{ selectedId: selectedId } };
                props.onSuccess(event, newProps);
            }
        }
    }

    return <>
        <form onSubmit={handleSubmit}>
            <fieldset>
                <div className='quick-drawer'>
                    <QuickDrawerHeader
                        drawer={props.drawer}
                        icon={'fal fa-code'}
                        action='Update'
                        category={`Template Variable`}
                        onCancel={handleCancel}
                    />
                    <div className='quick-drawer-body'>
                        {
                            selectedFormat ?
                                <FadeIn>
                                    <div className='update-communication-template-variable body-content'>
                                        <section>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group mb-4'>
                                                        <label><small>Variable</small></label>
                                                        <div className='fs-md fw-500'>
                                                            {`[ ${props.extraProps.variable.name} ]`}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group mb-4'>
                                                        <label htmlFor='update-communication-template-variable-format'><small>Format</small></label>
                                                        {
                                                            props.extraProps.variable.formats
                                                                .filter(f => props.extraProps.supportHtml === true || (props.extraProps.supportHtml === false && f.isHtml === false))
                                                                .map((f, fi) => {
                                                                    return <div
                                                                        key={`update-communication-template-variable-format-${fi}`}
                                                                        className='custom-control custom-radio mb-2'
                                                                    >
                                                                        <input
                                                                            id={`update-communication-template-variable-format-${fi}`}
                                                                            type='radio'
                                                                            name='updateCommunicationTemplateVariableFormat'
                                                                            className='custom-control-input'
                                                                            value={f.variable}
                                                                            checked={!!selectedFormat && selectedFormat.id === f.variable}
                                                                            onChange={(e) => { handleFormatChange(e, f) }}
                                                                        />
                                                                        <label
                                                                            htmlFor={`update-communication-template-variable-format-${fi}`}
                                                                            className='custom-control-label'
                                                                            dangerouslySetInnerHTML={{ __html: f.display }}
                                                                        >
                                                                        </label>
                                                                    </div>
                                                                })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                selectedFormat && selectedFormat.buttonSizes && selectedFormat.buttonSizes.length > 0 ?
                                                    <div className='row'>
                                                        <div className='col-12'>
                                                            <div className='form-group mb-4'>
                                                                <label htmlFor='update-communication-template-variable-button-size'>
                                                                    <small>Button size</small>
                                                                </label>
                                                                <div
                                                                    className='custom-control custom-radio mb-2'
                                                                >
                                                                    <input
                                                                        id='update-communication-template-variable-button-size'
                                                                        type='radio'
                                                                        name='updateCommunicationTemplateVariableButtonSize'
                                                                        className='custom-control-input'
                                                                        checked={!!selectedFormat && !selectedFormat.buttonSize}
                                                                        onClick={(e) => { handleButtonSizeChange(e, null) }}
                                                                    />
                                                                    <label
                                                                        htmlFor='update-communication-template-variable-button-size'
                                                                        className='custom-control-label'
                                                                    >
                                                                        Auto width
                                                                    </label>
                                                                </div>
                                                                {
                                                                    selectedFormat.buttonSizes.map((s, si) => {
                                                                        return <div
                                                                            key={`update-communication-template-variable-button-size-${si}`}
                                                                            className='custom-control custom-radio mb-2'
                                                                        >
                                                                            <input
                                                                                id={`update-communication-template-variable-button-size-${si}`}
                                                                                type='radio'
                                                                                name='updateCommunicationTemplateVariableButtonSize'
                                                                                className='custom-control-input'
                                                                                checked={!!selectedFormat && selectedFormat.buttonSize === s}
                                                                                onClick={(e) => { handleButtonSizeChange(e, s) }}
                                                                            />
                                                                            <label
                                                                                htmlFor={`update-communication-template-variable-button-size-${si}`}
                                                                                className='custom-control-label'
                                                                            >
                                                                                {s}%
                                                                            </label>
                                                                        </div>
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </div> : <></>
                                            }
                                            {
                                                selectedFormat && selectedFormat.id && selectedFormat.isTextChangeAllowed ?
                                                    <div className='row'>
                                                        <div className='col-12'>
                                                            <div className='form-group mb-4'>
                                                                <label htmlFor='update-communication-template-variable-text'>
                                                                    {getTextChangeLabel(selectedFormat.id)}
                                                                </label>
                                                                <input
                                                                    id='update-communication-template-variable-text'
                                                                    type='text'
                                                                    className='form-control'
                                                                    maxLength='50'
                                                                    autoComplete='off'
                                                                    value={selectedFormat && selectedFormat.text ? selectedFormat.text : ''}
                                                                    onChange={handleFormatTextChange}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div> : <></>
                                            }
                                        </section>
                                    </div>
                                </FadeIn> : <></>
                        }
                    </div>
                    <div className='quick-drawer-action'>
                        <div className='row'>
                            <div className='col-4'></div>
                            <div className='col-8'>
                                <div className='float-right'>
                                    <button
                                        type='button'
                                        className='btn btn-link btn-cancel mr-2'
                                        onClick={handleCancel}
                                    >Cancel</button>
                                    <button
                                        type='submit'
                                        className='btn btn-success'
                                    >Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset >
        </form >
    </>
}

export default UpdateCommunicationTemplateVariable;